var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector52(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 63,
    viewBox: "0 0 53 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9773 8.61967V49.0278H39.7884M51.9773 8.61967H44.7838V1.02783M51.9773 8.61967L44.7838 1.02783M44.7838 1.02783H20.6058V6.66049M24.6022 14.2523H47.7811M39.7884 49.0278H20.8056V49.0278C20.6953 49.0278 20.6058 48.9384 20.6058 48.828V6.66049M39.7884 49.0278L14.8111 61.0278L2.02271 17.9258L11.2143 13.7625M39.7884 49.0278L16.6094 54.9054L11.2143 13.7625M11.2143 13.7625L10.8147 9.35436L20.6058 6.66049M24.6022 21.1095H47.7811M47.7811 27.4768H24.6022M24.6022 34.0891H47.7811M47.7811 40.4564H24.6022",
    stroke: "#006D77",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector52);
export default __webpack_public_path__ + "static/media/Vector 52.f39dafda8aa6d0639a6a9beb1f41b65e.svg";
export { ForwardRef as ReactComponent };